function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["active", "activeIndex", "children", "className", "focusIndex", "id", "index", "tabPanelId"];
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { useRef, useEffect } from 'react';
import { BaseButton } from "../../../../atoms/button/base-button/base-button.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
/**
 * `tab` indicates an interactive element inside a `tablist` that, when activated, displays its associated `tabpanel`.
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/tab_role
 *
 * @param props TabButtonProps
 */
var TabButton = function TabButton(props) {
  var _props$active = props.active,
    active = _props$active === void 0 ? false : _props$active,
    activeIndex = props.activeIndex,
    children = props.children,
    className = props.className,
    focusIndex = props.focusIndex,
    id = props.id,
    index = props.index,
    tabPanelId = props.tabPanelId,
    otherProps = _objectWithoutProperties(props, _excluded);
  var ref = useRef(null);
  useEffect(function () {
    if (activeIndex === index && ref !== null && ref !== void 0 && ref.current) {
      ref.current.focus();
    }
  }, [activeIndex]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(function () {
    if (focusIndex !== null && focusIndex === index && ref !== null && ref !== void 0 && ref.current) {
      ref.current.focus();
    }
  }, [focusIndex]); // eslint-disable-line react-hooks/exhaustive-deps
  return /*#__PURE__*/React.createElement(BaseButton, _extends({}, otherProps, {
    ref: ref,
    "aria-controls": tabPanelId,
    "aria-selected": active,
    className: classnames(_defineProperty({
      'bf-tabs__tab': true
    }, "".concat(className), !!className)),
    id: id,
    role: "tab",
    tabIndex: active ? undefined : -1,
    type: "button"
  }), children);
};
export { TabButton };